export interface WikiEntry {
  slug: string
  titulo: string
  categoria: string
  resumo: string
  oQueE: string
  paraQueServe: string
  recomendacoes: string[]
  relacionados: string[]
  tags: string[]
}

export const WIKI_CATEGORIAS = [
  'Glossário',
  'Estrutura',
  'Materiais',
  'Financeiro',
  'Legal',
] as const

export const WIKI_ENTRIES: WikiEntry[] = [
  {
    slug: 'alvenaria-estrutural',
    titulo: 'Alvenaria Estrutural',
    categoria: 'Estrutura',
    resumo: 'Sistema em que as paredes de blocos suportam a carga da edificação.',
    oQueE:
      'Construção em que paredes de blocos estruturais (cerâmicos ou de concreto) funcionam como pilares e vigas, dispensando estrutura convencional de concreto armado em parte da obra.',
    paraQueServe:
      'Reduzir etapas de forma e concretagem, acelerar o cronograma em obras de padrão médio e integrar vedação com estrutura.',
    recomendacoes: [
      'Exige projeto estrutural específico e compatibilização com instalações.',
      'Atenção às amarrações, vergas e contraventamentos.',
      'Compare custo total (bloco + mão de obra especializada) com alvenaria convencional + concreto.',
    ],
    relacionados: ['steel-frame', 'cno'],
    tags: ['sistema construtivo', 'estrutura', 'bloco'],
  },
  {
    slug: 'steel-frame',
    titulo: 'Steel Frame',
    categoria: 'Estrutura',
    resumo: 'Estrutura leve em perfis de aço galvanizado com fechamento em placas.',
    oQueE:
      'Sistema construtivo com esqueleto metálico leve, painéis de fechamento (OSB, drywall, EPS) e isolamento térmico/acústico integrado.',
    paraQueServe:
      'Obra rápida, industrializada, com menor peso próprio · indicada para terrenos com restrições de carga ou prazos curtos.',
    recomendacoes: [
      'Verifique disponibilidade de equipe qualificada na região.',
      'Projeto deve detalhar pontos de fixação e expansão.',
      'Cuidado com pontes térmicas e detalhes de impermeabilização.',
    ],
    relacionados: ['alvenaria-estrutural', 'habite-se'],
    tags: ['sistema construtivo', 'metálica', 'industrializado'],
  },
  {
    slug: 'cno',
    titulo: 'CNO · Cadastro Nacional de Obras',
    categoria: 'Legal',
    resumo: 'Cadastro obrigatório da obra na Receita Federal para fins de INSS e fiscalização.',
    oQueE:
      'Registro eletrônico que identifica a obra perante a Receita Federal, base para cálculo e recolhimento do INSS de obra.',
    paraQueServe:
      'Regularizar a obra para emissão de notas, contratações formais e futura venda do imóvel sem pendências trabalhistas.',
    recomendacoes: [
      'Abra o CNO antes de iniciar a execução com mão de obra contratada.',
      'Guarde o comprovante nos Arquivos da obra.',
      'Atualize o cadastro em caso de mudança de responsável técnico ou área.',
    ],
    relacionados: ['inss-obra', 'habite-se'],
    tags: ['tributos', 'documentação', 'INSS'],
  },
  {
    slug: 'inss-obra',
    titulo: 'INSS de Obra',
    categoria: 'Legal',
    resumo: 'Contribuição previdenciária incidente sobre a construção civil.',
    oQueE:
      'Tributo calculado sobre o custo da obra (mão de obra + materiais em alguns regimes), recolhido durante a execução ou na conclusão.',
    paraQueServe:
      'Financiar a previdência dos trabalhadores da construção e liberar a obra para averbação e venda.',
    recomendacoes: [
      'O valor varia conforme o tipo de contratação (empreitada total, parcial, administração).',
      'Notas fiscais de materiais podem reduzir a base · organize os comprovantes.',
      'Simule antes de fechar o tipo de contratação.',
    ],
    relacionados: ['cno', 'empreitada-total'],
    tags: ['tributos', 'INSS', 'custo'],
  },
  {
    slug: 'empreitada-total',
    titulo: 'Empreitada Total',
    categoria: 'Financeiro',
    resumo: 'Contratação em que um único responsável executa a obra por preço fechado.',
    oQueE:
      'Modelo em que o empreiteiro assume risco de custo e prazo, entregando a obra conforme projeto por valor acordado.',
    paraQueServe:
      'Transferir complexidade de gestão e compras para o empreiteiro · indicado para quem não pode acompanhar a obra diariamente.',
    recomendacoes: [
      'Contrato detalhado com memorial descritivo e cronograma.',
      'Retenções e garantias por etapa concluída.',
      'INSS e CNO: entenda quem é o responsável pelo recolhimento.',
    ],
    relacionados: ['inss-obra', 'cno'],
    tags: ['contratação', 'mão de obra'],
  },
  {
    slug: 'habite-se',
    titulo: 'Habite-se',
    categoria: 'Legal',
    resumo: 'Documento municipal que autoriza o uso do imóvel após conclusão da obra.',
    oQueE:
      'Licença emitida pela prefeitura atestando que a edificação está conforme o projeto aprovado e normas de segurança.',
    paraQueServe:
      'Permitir moradia legal, ligação definitiva de serviços públicos e registro do imóvel em cartório.',
    recomendacoes: [
      'Providencie vistoria final com o responsável técnico.',
      'Arquive ART/RRT, laudos e alvará nos Arquivos da obra.',
      'Sem habite-se, a venda e financiamento ficam comprometidos.',
    ],
    relacionados: ['cno', 'alvara'],
    tags: ['documentação', 'entrega', 'prefeitura'],
  },
  {
    slug: 'alvara',
    titulo: 'Alvará de Construção',
    categoria: 'Legal',
    resumo: 'Autorização da prefeitura para iniciar a obra.',
    oQueE:
      'Licença municipal emitida após análise do projeto arquitetônico e documentação do terreno.',
    paraQueServe: 'Legalizar o início da construção e evitar multas, embargo ou demolição.',
    recomendacoes: [
      'Não inicie a obra sem alvará válido.',
      'Confira prazo de validade e condicionantes (recuos, gabarito).',
      'Guarde cópia digital nos Arquivos.',
    ],
    relacionados: ['habite-se', 'cno'],
    tags: ['documentação', 'prefeitura', 'projeto'],
  },
  {
    slug: 'concreto-usinado',
    titulo: 'Concreto Usinado',
    categoria: 'Materiais',
    resumo: 'Concreto produzido em central e entregue pronto na obra.',
    oQueE:
      'Mistura de cimento, agregados e água preparada industrialmente, transportada em betoneiras até o local da concretagem.',
    paraQueServe:
      'Garantir traço controlado, agilizar fundações e lajes, reduzir mão de obra no preparo.',
    recomendacoes: [
      'Programe a bomba e a equipe de lançamento com antecedência.',
      'Exija nota fiscal e laudo de slump a cada carga.',
      'Nunca adicione água na betoneira sem orientação do projetista.',
    ],
    relacionados: ['alvenaria-estrutural'],
    tags: ['material', 'fundação', 'estrutura'],
  },
  {
    slug: 'impermeabilizacao',
    titulo: 'Impermeabilização',
    categoria: 'Materiais',
    resumo: 'Barreira contra infiltração de água em lajes, banheiros e fundações.',
    oQueE:
      'Camada ou sistema (manta, argamassa polimérica, membrana) aplicado em superfícies expostas à umidade.',
    paraQueServe:
      'Evitar infiltrações, mofo, corrosão de armaduras e perda de durabilidade da estrutura.',
    recomendacoes: [
      'Impermeabilize antes de revestir · retrabalho é caro.',
      'Registre fotos de cada camada nos Arquivos da obra.',
      'Respeite tempo de cura entre demãos.',
    ],
    relacionados: ['concreto-usinado'],
    tags: ['material', 'execução', 'infiltração'],
  },
  {
    slug: 'custo-por-m2',
    titulo: 'Custo por m²',
    categoria: 'Financeiro',
    resumo: 'Indicador que divide o custo total da obra pela área construída.',
    oQueE:
      'Métrica de benchmark: R$/m² = custo total estimado ÷ área construída (incluindo paredes, não só área útil).',
    paraQueServe:
      'Comparar orçamentos, padrões de acabamento e viabilidade financeira com obras similares.',
    recomendacoes: [
      'Separe custo de terreno do custo de construção.',
      'Ajuste por padrão (econômico, médio, nobre) e região.',
      'Use como referência, não como orçamento fechado.',
    ],
    relacionados: ['empreitada-total'],
    tags: ['orçamento', 'financeiro', 'benchmark'],
  },
  {
    slug: 'art-rrt',
    titulo: 'ART / RRT',
    categoria: 'Legal',
    resumo: 'Anotação de Responsabilidade Técnica · registro da atuação do profissional na obra.',
    oQueE:
      'Documento emitido por conselho de classe (CREA/CAU) que vincula o profissional habilitado à execução ou projeto da obra.',
    paraQueServe:
      'Comprovar responsabilidade técnica perante prefeitura, bancos e compradores; exigido para alvará e regularização.',
    recomendacoes: [
      'Exija ART/RRT antes de iniciar serviços técnicos.',
      'Guarde cópias nos Arquivos da obra.',
      'Verifique se cobre a etapa correta (projeto, execução, laudo).',
    ],
    relacionados: ['alvara', 'habite-se'],
    tags: ['documentação', 'projeto', 'legal'],
  },
  {
    slug: 'contraverga',
    titulo: 'Contraverga',
    categoria: 'Glossário',
    resumo: 'Viga ou bloco sobre o vão de porta ou janela que redistribui a carga da alvenaria.',
    oQueE:
      'Elemento estrutural (concreto, aço ou bloco estrutural) instalado acima de vãos para evitar fissuras e colapsos na parede.',
    paraQueServe:
      'Transferir o peso da alvenaria acima do vão para as laterais, preservando integridade da parede.',
    recomendacoes: [
      'Respeite o projeto · não improvisar dimensões.',
      'Aguarde cura antes de assentar blocos sobre a verga.',
      'Registre posição e tipo nos diário de obra.',
    ],
    relacionados: ['alvenaria-estrutural'],
    tags: ['estrutura', 'alvenaria', 'execução'],
  },
  {
    slug: 'laje-pre-moldada',
    titulo: 'Laje pré-moldada',
    categoria: 'Estrutura',
    resumo: 'Laje industrializada montada com vigotas, treliças ou painéis pré-fabricados.',
    oQueE:
      'Sistema de laje montada com elementos produzidos em fábrica, concretados ou encaixados in loco.',
    paraQueServe:
      'Agilizar obra, reduzir escoramento e padronizar qualidade em grandes vãos repetitivos.',
    recomendacoes: [
      'Confirme capacidade de carga e vão livre com o projetista.',
      'Planeje içamento e equipe especializada.',
      'Compare custo total com laje maciça convencional.',
    ],
    relacionados: ['concreto-usinado', 'alvenaria-estrutural'],
    tags: ['estrutura', 'laje', 'industrializado'],
  },
  {
    slug: 'projeto-hidraulico',
    titulo: 'Projeto hidráulico',
    categoria: 'Glossário',
    resumo: 'Planta das tubulações de água fria, quente, esgoto e pluvial da edificação.',
    oQueE:
      'Desenho técnico com diâmetros, declividades, pontos de uso e reservatórios · base para execução e aprovação.',
    paraQueServe:
      'Evitar retrabalho, dimensionar reservatórios e garantir pressão e vazão adequadas.',
    recomendacoes: [
      'Compatibilize com projeto elétrico e estrutural antes de executar.',
      'Fotografe tubulações antes de fechar paredes.',
      'Teste estanqueidade antes de revestir.',
    ],
    relacionados: ['projeto-eletrico'],
    tags: ['projeto', 'instalações', 'hidráulica'],
  },
  {
    slug: 'projeto-eletrico',
    titulo: 'Projeto elétrico',
    categoria: 'Glossário',
    resumo: 'Planta de pontos, circuitos, disjuntores e aterramento da instalação elétrica.',
    oQueE:
      'Documento técnico que define cargas, bitolas, quadro de distribuição (QDG/QD) e pontos de luz/tomada.',
    paraQueServe: 'Dimensionar fiação segura, prever demanda e facilitar manutenção futura.',
    recomendacoes: [
      'Preveja pontos extras · mudar depois de rebocado é caro.',
      'Exija projeto conforme NBR 5410.',
      'Registre alterações de campo no diário.',
    ],
    relacionados: ['projeto-hidraulico'],
    tags: ['projeto', 'instalações', 'elétrica'],
  },
  {
    slug: 'bdi',
    titulo: 'BDI',
    categoria: 'Financeiro',
    resumo: 'Benefícios e Despesas Indiretas · percentual sobre custo direto do orçamento.',
    oQueE:
      'Índice que cobre administração, impostos, seguros, lucro e riscos do empreendimento sobre materiais e mão de obra direta.',
    paraQueServe: 'Transformar custo direto em preço de venda ou orçamento executivo realista.',
    recomendacoes: [
      'BDI varia por tipo de obra e regime tributário.',
      'Orçamentos muito baixos podem esconder BDI insuficiente.',
      'Compare propostas sempre pelo custo direto + BDI explícito.',
    ],
    relacionados: ['custo-por-m2', 'empreitada-total'],
    tags: ['orçamento', 'financeiro', 'gestão'],
  },
  {
    slug: 'prumo-e-nivel',
    titulo: 'Prumo e nível',
    categoria: 'Glossário',
    resumo: 'Controles geométricos essenciais na execução de alvenaria e revestimentos.',
    oQueE:
      'Prumo verifica verticalidade; nível verifica horizontalidade e planicidade de superfícies.',
    paraQueServe:
      'Evitar paredes inclinadas, pisos ondulados e problemas em esquadrias e revestimentos.',
    recomendacoes: [
      'Confira a cada fiada de bloco, não só no final.',
      'Use laser para grandes vãos.',
      'Registre não conformidades com foto.',
    ],
    relacionados: ['impermeabilizacao'],
    tags: ['execução', 'qualidade', 'alvenaria'],
  },
  {
    slug: 'manta-asfaltica',
    titulo: 'Manta asfáltica',
    categoria: 'Materiais',
    resumo: 'Material impermeabilizante comum em lajes e fundações.',
    oQueE:
      'Rolo de asfalto modificado com armadura polimérica, aplicado com maçarico ou adesivo conforme sistema.',
    paraQueServe: 'Impermeabilizar lajes expostas, baldrames e áreas de contato com solo.',
    recomendacoes: [
      'Respeite sobreposição e altura mínima de rodapé (pingadeira).',
      'Proteja mecanicamente antes de acabamento.',
      'Não aplicar com umidade ou chuva.',
    ],
    relacionados: ['impermeabilizacao'],
    tags: ['material', 'cobertura', 'infiltração'],
  },
  {
    slug: 'regularizacao-fundiaria',
    titulo: 'Regularização fundiária',
    categoria: 'Legal',
    resumo: 'Processo de legalizar posse ou propriedade do terreno perante cartório e prefeitura.',
    oQueE:
      'Conjunto de procedimentos (REURB, usucapião, loteamento) para obter matrícula e documentação válida do imóvel.',
    paraQueServe: 'Permitir financiamento, alvará de construção e registro da obra futura.',
    recomendacoes: [
      'Resolva pendências fundiárias antes de contratar projeto executivo.',
      'Consulte cartório de registro de imóveis cedo.',
      'Documente toda a cadeia de compra nos Arquivos.',
    ],
    relacionados: ['alvara', 'habite-se'],
    tags: ['terreno', 'legal', 'documentação'],
  },
]

export function getWikiEntry(slug: string): WikiEntry | undefined {
  return WIKI_ENTRIES.find((e) => e.slug === slug)
}

export function searchWiki(query: string): WikiEntry[] {
  const q = query.trim().toLowerCase()
  if (q.length < 2) return []
  return WIKI_ENTRIES.filter(
    (e) =>
      e.titulo.toLowerCase().includes(q) ||
      e.resumo.toLowerCase().includes(q) ||
      e.tags.some((t) => t.includes(q)) ||
      e.categoria.toLowerCase().includes(q),
  )
}
